import { K8sProviderIcon } from '@cast/features-cluster-ui';

import { DialogTitle, Typography, Stack } from '@cast/design-system';

import { DialogCloseActions } from './DialogCloseActions';

import { useCluster } from '@cast/shared-cluster-context-data-access';

type Props = {
  dismiss?: () => void;
};

export const AssignCredentialsDialogHeader = ({ dismiss }: Props) => {
  const { cluster } = useCluster();

  return (
    <DialogTitle component="div" sx={{ pt: 16, pb: 24 }}>
      <Stack direction="row" gap={4} justifyContent="space-between">
        <Stack direction="row" alignItems="center" gap={8} flexWrap="nowrap">
          <K8sProviderIcon provider={cluster.providerType} size={24} />
          <Typography variant="h5">{cluster.name}</Typography>
        </Stack>

        <DialogCloseActions dismiss={dismiss} />
      </Stack>
    </DialogTitle>
  );
};
